import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const userRole = localStorage.getItem("adminRole");

  const handleDropdownToggle = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleLogout = () => {
    const logoutPath =
      userRole === "staff" || userRole === "admin" || userRole === "superadmin"
        ? "/admin/login"
        : "/customer/login";
    window.location.href = logoutPath;
  };

  const handleProfileNavigation = () => {
    if (
      userRole === "staff" ||
      userRole === "admin" ||
      userRole === "superadmin"
    ) {
      navigate(`/admin/dashboard/profile`);
    } else {
      navigate("/customer/dashboard/profile");
    }
  };

  return (
    <div className="navbar">
      <input type="text" placeholder="Search" className="search-bar" />
      <div className="user-section">
        {(userRole === "admin" || userRole === "superadmin") && (
          <Link to="/pending-requests">
            <button className="pending-info-button">Pending Request 🔔</button>
          </Link>
        )}
        <div className="user-icon" onClick={handleDropdownToggle}>
          AB
          {dropdownVisible && (
            <div className="dropdown-menu">
              <div onClick={handleProfileNavigation}>Profile</div>
              <div onClick={() => navigate("/settings")}>Settings</div>
              <div onClick={handleLogout}>Logout</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
